<template>
  <section>
    <div class="wrap">
      <div id="slide_wrap">
        <figure id="title-01" class="slide_item zoom_ show_">
          <img src="/top_img/2026/2026_title.jpg" alt="たちかわ演劇祭">
        </figure>
        <figcaption value="title-01" class="caption_item show_">
        </figcaption>

        <figure id="top01-01" class="slide_item"><img src="/top_img/2026/2026_1_noukyou.jpg" alt="脳響トーンシステム"></figure>
        <figcaption value="top01-01" class="caption_item">脳響トーンシステム</figcaption>
        <figure id="top01-02" class="slide_item"><img src="/top_img/2026/2026_1_noukyou.jpg" alt="脳響トーンシステム"></figure>
        <figcaption value="top01-02" class="caption_item">脳響トーンシステム</figcaption>
        <figure id="top01-03" class="slide_item"><img src="/top_img/2026/2026_1_noukyou.jpg" alt="脳響トーンシステム"></figure>
        <figcaption value="top01-03" class="caption_item">脳響トーンシステム</figcaption>

        <figure id="top02-01" class="slide_item"><img src="/top_img/2026/2026_2_shibaiya.jpg" alt="劇団 芝居屋樂屋"></figure>
        <figcaption value="top02-01" class="caption_item">劇団 芝居屋樂屋</figcaption>
        <figure id="top02-02" class="slide_item"><img src="/top_img/2026/2026_2_shibaiya.jpg" alt="劇団 芝居屋樂屋"></figure>
        <figcaption value="top02-02" class="caption_item">劇団 芝居屋樂屋</figcaption>
        <figure id="top02-03" class="slide_item"><img src="/top_img/2026/2026_2_shibaiya.jpg" alt="劇団 芝居屋樂屋"></figure>
        <figcaption value="top02-03" class="caption_item">劇団 芝居屋樂屋</figcaption>

        <figure id="top03-01" class="slide_item vertical"><img src="/top_img/2026/2026_3_tachikawakoukou.jpg" alt="都立立川高校演劇部"></figure>
        <figcaption value="top03-01" class="caption_item">都立立川高校演劇部</figcaption>
        <figure id="top03-02" class="slide_item vertical"><img src="/top_img/2026/2026_3_tachikawakoukou.jpg" alt="都立立川高校演劇部"></figure>
        <figcaption value="top03-02" class="caption_item">都立立川高校演劇部</figcaption>
        <figure id="top03-03" class="slide_item vertical"><img src="/top_img/2026/2026_3_tachikawakoukou.jpg" alt="都立立川高校演劇部"></figure>
        <figcaption value="top03-03" class="caption_item">都立立川高校演劇部</figcaption>

        <figure id="top04-01" class="slide_item"><img src="/top_img/2026/2026_4_kotonomi_1.jpg" alt="演劇仲間ことのみ"></figure>
        <figcaption value="top04-01" class="caption_item">演劇仲間ことのみ</figcaption>
        <figure id="top04-02" class="slide_item"><img src="/top_img/2026/2026_4_kotonomi_2.jpg" alt="演劇仲間ことのみ"></figure>
        <figcaption value="top04-02" class="caption_item">演劇仲間ことのみ</figcaption>
        <figure id="top04-03" class="slide_item"><img src="/top_img/2026/2026_4_kotonomi_2.jpg" alt="演劇仲間ことのみ"></figure>
        <figcaption value="top04-03" class="caption_item">演劇仲間ことのみ</figcaption>

        <figure id="top05-01" class="slide_item"><img src="/top_img/2026/2026_5_kingsmen_1.jpg" alt="劇団キングスメン"></figure>
        <figcaption value="top05-01" class="caption_item">劇団キングスメン</figcaption>
        <figure id="top05-02" class="slide_item"><img src="/top_img/2026/2026_5_kingsmen_2.jpg" alt="劇団キングスメン"></figure>
        <figcaption value="top05-02" class="caption_item">劇団キングスメン</figcaption>
        <figure id="top05-03" class="slide_item"><img src="/top_img/2026/2026_5_kingsmen_3.jpg" alt="劇団キングスメン"></figure>
        <figcaption value="top05-03" class="caption_item">劇団キングスメン</figcaption>

        <figure id="top06-01" class="slide_item"><img src="/top_img/2026/2026_6_firstline_1.jpg" alt="劇団Firstline"></figure>
        <figcaption value="top06-01" class="caption_item">劇団Firstline</figcaption>
        <figure id="top06-02" class="slide_item"><img src="/top_img/2026/2026_6_firstline_2.jpg" alt="劇団Firstline"></figure>
        <figcaption value="top06-02" class="caption_item">劇団Firstline</figcaption>
        <figure id="top06-03" class="slide_item"><img src="/top_img/2026/2026_6_firstline_2.jpg" alt="劇団Firstline"></figure>
        <figcaption value="top06-03" class="caption_item">劇団Firstline</figcaption>

        <figure id="top07-01" class="slide_item"><img src="/top_img/2026/2026_7_kajikita.jpg" alt="カジキタドリーム"></figure>
        <figcaption value="top07-01" class="caption_item">カジキタドリーム</figcaption>
        <figure id="top07-02" class="slide_item"><img src="/top_img/2026/2026_7_kajikita.jpg" alt="カジキタドリーム"></figure>
        <figcaption value="top07-02" class="caption_item">カジキタドリーム</figcaption>
        <figure id="top07-03" class="slide_item"><img src="/top_img/2026/2026_7_kajikita.jpg" alt="カジキタドリーム"></figure>
        <figcaption value="top07-03" class="caption_item">カジキタドリーム</figcaption>

      </div>
    </div>
  </section>
</template>
<script>
export default {
  computed: {
    slideList() {
      return this.$store.getters.getSlideList;
    },
  },
  mounted: function () {
    const slideItems = document.querySelectorAll('#slide_wrap > figure.slide_item'); //スライド要素
    const captionItems = document.querySelectorAll('#slide_wrap > figcaption.caption_item'); //キャプション要素

    let groups = [];
    slideItems.forEach((slideItem, slideKey) => {
      let slideId = slideItem.getAttribute("id")
      if (slideId.indexOf('-') == -1) {
        return;
      }
      let slideIdArray = slideId.split('-');
      let group = slideIdArray[0];

      if (group in groups) {
        groups[group].push(slideKey);
      } else {
        groups[group] = [];
        groups[group].push(slideKey);
      }
    })
    delete groups['title'];
    let groupsArray = [];
    for (let i in groups) {
      groupsArray.push(groups[i]);
    }

    const FadeTime = 2000; //フェードインの時間
    const IntarvalTime = 5000; //クロスフェードさせるまでの間隔
    let currentNumber = 0; //現在アクティブな番号
    let nextNumber = 0; //次に表示するスライド番号
    let countNumber = 0; //カウント
    let currentSlide; //現在表示中のスライド
    let nextSlide; //次に表示するスライド
    let currentCaption; //現在表示中のキャプション
    let nextCaption; //次に表示するキャプション
    let currentGroupNumber = 0;
    let nextGroupNumber = 0;
    let maxGroupNumber = Object.keys(groups).length - 1;
    let nextGroup;
    let nextChildNumber = 0;
    let maxChildNumber;

    // DOM読み込み時にスライドの1枚目をフェードイン
    slideItems[0].classList.add('show_', 'zoom_');
    captionItems[0].classList.add('show_');

    // 処理を繰り返す
    setInterval(() => {
      currentSlide = slideItems[currentNumber];
      currentCaption = captionItems[currentNumber];
      if (countNumber < 3) {
        do {
          nextGroupNumber = random(maxGroupNumber);
        } while (currentGroupNumber == nextGroupNumber);

        nextGroup = groupsArray[nextGroupNumber];
        currentGroupNumber = nextGroupNumber;

        maxChildNumber = nextGroup.length - 1;
        nextChildNumber = random(maxChildNumber);
        nextNumber = nextGroup[nextChildNumber];

        countNumber++;
      } else {
        nextNumber = 0;
        countNumber = 0;
      }
      nextSlide = slideItems[nextNumber];
      nextCaption = captionItems[nextNumber];

      //.show_削除でフェードアウト
      currentSlide.classList.remove('show_');
      currentCaption.classList.remove('show_');

      // 次のスライドがフェードインする
      nextSlide.classList.add('show_');
      if (nextNumber != 0) {
        // 次のスライドがタイトル以外のときはズームする
        nextSlide.classList.add('zoom_');
      }

      if (currentNumber != 0) {
        // 現在のスライドがタイトル以外のときはズームを除去
        setTimeout(() => {
          currentSlide.classList.remove('zoom_');
        }, FadeTime);
      }
      nextCaption.classList.add('show_');

      currentNumber = nextNumber
    }, IntarvalTime);
  },
};

function random(max, min = 0) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}
</script>
<style>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

img {
  max-width: 100%;
  height: auto;
}

body {
  line-height: 1.6;
}

/* .wrap{max-width: 812.156px;} */
.demo_title {
  text-align: center;
  padding: 8px;
}

.wrap {
  padding: 0px;
}

#slide_wrap {
  position: relative;
  overflow: hidden;
  object-fit: cover;
  max-height: 800px;
}

#slide_wrap .slide_item {
  opacity: 0;
  transform: scale(1.00);
  transition: opacity 2s linear, transform 7.5s linear;
  position: relative;
  display: table-cell;
  text-align: center;
  vertical-align: middle;
  -o-object-fit: cover;
  object-fit: cover;
  width: 100%;
  height: 100%
}

#slide_wrap .slide_item:not(:first-child) {
  position: absolute;
  top: 0;
  left: 0;
  -o-object-fit: cover;
  object-fit: cover;
  width: 100%;
  height: 100%
}

#slide_wrap .slide_item.show_ {
  opacity: 1;
}

#slide_wrap .slide_item.zoom_ {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

#slide_wrap .slide_item:first-child.zoom_ {
  -webkit-transform: scale(1);
  transform: scale(1.00);
}

#slide_wrap .slide_item img {
  display: block;
  -o-object-fit: cover !important;
  object-fit: cover !important;
  width: 100%;
  height: 100%;
  min-height: 100%;
}

/* Safari */
@media screen and (-webkit-min-device-pixel-ratio: 0) {
  _::-webkit-full-page-media, _:future, #slide_wrap {
    height: 300px !important;
  }

  _::-webkit-full-page-media, _:future, #slide_wrap figure{
    height: 300px !important;
  }
  
  _::-webkit-full-page-media, _:future, #slide_wrap .slide_item img {
    height: 300px !important;
  }
}

#slide_wrap .slide_item.vertical {
  background-color: #000;
  -o-object-fit: contain;
  object-fit: contain;
  -o-object-position: center;
  object-position: center;
}
#slide_wrap .slide_item.vertical img {
  height: 100%;
  width: auto;
  display: block;
  margin:auto;
}

#slide_wrap .caption_item {
  opacity: 0;
  transition: opacity 1s linear, transform 7.5s linear;
  position: absolute;
  bottom: 2em;
  color: #fff;
  background: rgba(0, 0, 0, .3);
  margin: 0;
  padding: 0 0.8em;
}

#slide_wrap .caption_item:not(:first-child) {
  /* position: relative; */
  position: absolute;
  /* top: 0; */
  /* left: 0; */
}

#slide_wrap .caption_item.show_ {
  opacity: 1;
}

#slide_wrap .caption_item {
  display: block;
}

.top_image {
  position: relative;
  width: 600px;
}

.top_caption {
  position: absolute;
  bottom: 80px;
  color: #fff;
  background: rgba(0, 0, 0, .6);
  width: 100%;
  max-width: 600px;
  padding: 1em 0;
}

.top_caption p {
  margin: 0;
  padding: 0 0.8em;
  font-size: 150%;
  text-align: center;
}
</style>
